<template>
  <div class="article-generator text-article">
    <h1>{{ props.title }}</h1>
    <hr />
    <div class="content-wrapper">
      <template v-for="(item, i) in props.content" :key="`content-${i}`">
        <template v-if="item.type === ArticleContentStructureType.IMAGE">
          <img v-bind="item" />
        </template>

        <template v-else-if="item.type === ArticleContentStructureType.HTML">
          <div v-html="item.content"></div>
        </template>

        <template v-else>
          <component :is="getTag(item)" :class="item.class">
            <template v-if="checkIsList(item)">
              <li v-for="(c, contentIndex) in item.content" :key="contentIndex">{{ c }}</li>
            </template>
            <template v-else>
              {{ item.content }}
            </template>
          </component>
        </template>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ArticleContentStructure } from '@/types/article-generator'
import { ArticleContentStructureType } from '@/types/article-generator'
const props = defineProps<{ title: string; content: ArticleContentStructure[] }>()

const checkIsList = (item: ArticleContentStructure) => {
  return (
    Array.isArray(item.content) &&
    (item.type === ArticleContentStructureType.UNORDERED_LIST || item.type === ArticleContentStructureType.ORDERED_LIST)
  )
}

const getTag = (item: ArticleContentStructure) => {
  switch (item.type) {
    case ArticleContentStructureType.HEADING:
      return 'h2'
    case ArticleContentStructureType.PARAGRAPH:
      return 'p'
    case ArticleContentStructureType.UNORDERED_LIST:
      return 'ul'
    case ArticleContentStructureType.ORDERED_LIST:
      return 'ol'
    case ArticleContentStructureType.IMAGE:
      return 'img'
    case ArticleContentStructureType.HTML:
      return 'div'
    default:
      return 'div'
  }
}
</script>

<style lang="scss" scoped>
.article-generator {
  @apply text-base tracking-0.5px;
  h1 {
    @apply text-2xl md:text-3xl my-6;
  }
  hr {
    @apply mt-6 mb-12;
  }
  h2 {
    @apply text-xl my-6;
  }
}
</style>
